import { render, staticRenderFns } from "./ObservationStats.vue?vue&type=template&id=734a1ca8&"
import script from "./ObservationStats.vue?vue&type=script&lang=js&"
export * from "./ObservationStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports